import { useContext, useState } from "react";
import { DrawerContext } from "../../../../store/DrawerContext/DrawerContext";
import { Card, Divider, Drawer, Image, Modal, Radio, Select, Tag, message } from "antd";
import { useFetch } from "../../../../hooks/useFetch/useFetch";
import { useTranslation } from "react-i18next";
import { PostScheduled } from "../posts/PostScheduled";
import { useAuth } from "../../../../store/AuthContext/AuthContext";
import { DrawerPanelTitle, drawerPanelStyles } from "../../../pages/common/Drawers/DrawerPanelTitle";
import TableLZM from "../../design/table/TableLZM";
import { CalendarOutlined, CheckCircleFilled, ClockCircleFilled, CloseCircleFilled, DeleteOutlined, RocketFilled } from "@ant-design/icons";
import moment from "moment";
import { POSTTYPES } from "../../../../common/constants/postTypes";
import { ExpandableText } from "../../../../common/utils/ExpandableText";
import { authFetch } from "../../../../common/request/authFetch";
import { ButtonLZ } from "../../design/Buttons/ButtonLZ";
import { useIsAuthorized } from "../../../pages/common/roles/Roles";

export const ScheduledPostsDrawer = () => {

    const { scheduledPostsDrawer, setScheduledPostsDrawer } = useContext(DrawerContext);    
    const [location, setLocation] = useState<any>();
    const [scheduledPosts, setScheduledPosts] = useState<any>([]);    
    const { projectGroup } = useAuth();
    const [updateData, setUpdateData] = useState(false);    
    const { t } = useTranslation();
    const isAuthorized = useIsAuthorized();

    useFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${scheduledPostsDrawer.locationId}/postsScheduled?status=${scheduledPostsDrawer.status}&periodOpt=${scheduledPostsDrawer?.selectedType}`, {}, [updateData],
    (data: any) => {
        setLocation(data.location);
        setScheduledPosts(data.scheduledPosts);
    });
    
    const deleteScheduledPost = async(id: string) => {
        await authFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/postsScheduled/${id}` , { method: 'DELETE'})
		.then((res) => {
            if (res) {
                message.success('Programación eliminada correctamente', 3);			  
                setScheduledPostsDrawer(null);
		  } else {
			  message.error('Error inesperado al borrar la programación', 3);
		  }
		})
	  }

    const columns = [	  
        {
          title: 'Foto',
          key: 'summary',
          align:'center',
          width: '200px',		
          render: (record: any) => (
              <div style={{minHeight:'200px', display:'flex', justifyContent: 'center'}}>
                  {record.post.photosURL.length > 0 ? 
                      <Image
                          width={200}                          
                          style={{borderRadius:'20px'}}						
                          src={record.post?.photosURL[0]}
                      />
                      :
                      <h3 style={{color:'silver', display:'flex', justifyContent: 'center', alignItems:'center'}}><b>Sin foto</b></h3>
                  }
              </div>
          )
        },
        {
            title: 'Detalle',
            key: 'summary',		
            render: (record: any) => (
                <div><ExpandableText text={record.post.summary}></ExpandableText></div>
                )
        },		
        {
            title: '',
            key: 'local',
            render: (record: any) => (
                <Card bodyStyle={{ background: 'white', borderRadius: '20px' }}>
                    <div>						
                        <div style={{color:SCHEDULED_STATUS_COLOR[record.status].color}}><b>{SCHEDULED_STATUS_COLOR[record.status].icon} {SCHEDULED_STATUS_COLOR[record.status].title}</b></div>
                        {record.error && <div style={{color: 'MediumVioletRed'}}>Error: {record.error}</div>}
                        <div>{moment(record.scheduledDate).format('ll')}</div>
                        <div><Tag style={{ borderRadius: '20px'}}>{POSTTYPES[record.post.type]}</Tag></div>
                        <div style={{ display: 'flex', justifyContent:'flex-end', marginBottom:'5px'}}>          
                        <ButtonLZ
                            type='link'
                            disabled={!isAuthorized(['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_CLIENT', 'ROLE_MODULE_CONTENT'])}
                            onClick={
                                () => {
                                Modal.confirm({
                                    title: '¿Confirma el borrado de esta programación?',
                                    okText: 'Confirmar',
                                    cancelText: 'Cancelar',
                                    onOk() {
                                    deleteScheduledPost(record.id)
                                    }
                                });
                                }
                            }>
                                <DeleteOutlined/> Eliminar 
                            </ButtonLZ>
                        </div>	
                    </div>                    
                </Card>
              )
          }
      ]      

    return (
        <>
            {scheduledPostsDrawer && (
                <Drawer
                    placement="right"
                    width={'50%'}
                    open={scheduledPostsDrawer != null}
                    onClose={() => setScheduledPostsDrawer(null)}
                    {...drawerPanelStyles}
                    title={
                        <DrawerPanelTitle
                            title={scheduledPostsDrawer.status === 'SCHEDULED' ? 'Programaciones Pendientes' : 'Programaciones con Error'}
                            location={location}
                        />
                    }>
                     <div style={{display:'flex', color:'slategray', justifyContent:'right', alignItems:'center', marginRight:'20px'}}>                    
                    </div>
                    <div style={{ margin: '20px' }}>
                        <TableLZM rowKey={'name'} columns={columns} dataSource={scheduledPosts} loading={false} showHeader={false}/>				
                    </div>			 
                </Drawer>
            )}
        </>
    );
};

const SCHEDULED_STATUS_COLOR: {[key:string] : any } = {
    SCHEDULED: {title: 'Pendiente', color:'dodgerblue', icon:<ClockCircleFilled/>},
    LAUNCHED: {title: 'Iniciada', color:'green', icon:<CheckCircleFilled/>},
    ERROR: {title: 'Error', color:'MediumVioletRed', icon:<CloseCircleFilled/>},
  }